const backToTop = (scrollBehavior) => () => {
  window.scroll({
    top: 0,
    behavior: scrollBehavior,
  })
}

const showHideOnScroll = (
  backToTopElement,
  hiddenClass,
  showThreshold,
) => () => {
  if (
    showThreshold < document.body.scrollTop || // For Safari
    showThreshold < document.documentElement.scrollTop // For Chrome, Firefox, IE and Opera
  ) {
    backToTopElement.classList.remove(hiddenClass)
  } else {
    backToTopElement.classList.add(hiddenClass)
  }
}

export default (
  id,
  hiddenClass,
  showThreshold = 100,
  scrollBehavior = 'smooth',
) => {
  const backToTopElement = document.getElementById(id)
  if (backToTopElement) {
    backToTopElement.addEventListener('click', backToTop(scrollBehavior))
    window.addEventListener(
      'scroll',
      showHideOnScroll(backToTopElement, hiddenClass, showThreshold),
    )
  }
}
